const DeviceVendorIcon = ({ name, color = "#000", size = "24" }) => {
  console.log("DeviceVendorIcon name=", name);
  if (name === "Apple") {
    return (
      <svg
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1263 1500"
        width={size}
        height={size}
      >
        <path
          id=""
          fill={color}
          d="M1053 1440C971.7 1518.9 882 1506.6 796.5 1469.4C705.6 1431.45 622.5 1429.05 526.5 1469.4C406.95 1521 343.5 1506 271.5 1440C-135 1021.5 -75 384 387 360C499.05 366 577.5 421.95 643.5 426.6C741.6 406.65 835.5 349.5 940.5 357C1066.65 367.2 1161 417 1224 506.55C964.5 662.55 1026 1004.55 1264.35 1100.55C1216.65 1225.8 1155.45 1349.55 1052.85 1441.05L1053 1440ZM634.5 355.5C622.35 169.5 773.1 16.5 946.5 1.5C970.35 216 751.5 376.5 634.5 355.5Z"
        />
      </svg>
    );
  } else if (name === "Windows") {
    return (
      <svg
        fill="#000000"
        width={size}
        height={size}
        viewBox="0 0 256 256"
        id=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={color}
          d="M112,144v51.63672a7.9983,7.9983,0,0,1-9.43115,7.87061l-64-11.63623A8.00019,8.00019,0,0,1,32,184V144a8.00008,8.00008,0,0,1,8-8h64A8.00008,8.00008,0,0,1,112,144ZM109.126,54.2217a7.995,7.995,0,0,0-6.55713-1.729l-64,11.63623A8.00017,8.00017,0,0,0,32,72v40a8.00008,8.00008,0,0,0,8,8h64a8.00008,8.00008,0,0,0,8-8V60.3633A7.99853,7.99853,0,0,0,109.126,54.2217Zm112-20.36377a7.99714,7.99714,0,0,0-6.55713-1.729l-80,14.5459A7.99965,7.99965,0,0,0,128,54.54543V112a8.00008,8.00008,0,0,0,8,8h80a8.00008,8.00008,0,0,0,8-8V40A8.00028,8.00028,0,0,0,221.126,33.85793ZM216,136H136a8.00008,8.00008,0,0,0-8,8v57.45459a7.99967,7.99967,0,0,0,6.56885,7.87061l80,14.5459A8.0001,8.0001,0,0,0,224,216V144A8.00008,8.00008,0,0,0,216,136Z"
        />
      </svg>
    );
  } else if (name === "Google") {
    return (
      <svg
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1556 1587"
        width="1556"
        height="1587"
      >
        <g id="Layer">
          <path
            fill="#4285f4"
            d="M1555.26 810.89C1555.26 745.67 1549.96 698.07 1538.51 648.72L793.5 648.72L793.5 943.1L1230.8 943.1C1221.99 1016.26 1174.38 1126.44 1068.58 1200.47L1067.09 1210.33L1302.65 1392.76L1318.97 1394.39C1468.85 1256 1555.26 1052.4 1555.26 810.89Z"
          />
          <path
            fill="#34a853"
            d="M793.5 1586.53C1007.74 1586.53 1187.6 1516.02 1318.97 1394.39L1068.58 1200.47C1001.57 1247.19 911.64 1279.8 793.5 1279.8C583.66 1279.8 405.57 1141.42 342.08 950.16L332.78 950.95L87.84 1140.45L84.64 1149.35C215.12 1408.48 483.15 1586.53 793.5 1586.53Z"
          />
          <path
            fill="#fbbc05"
            d="M342.08 950.16C325.33 900.8 315.64 847.91 315.64 793.27C315.64 738.62 325.33 685.73 341.2 636.37L340.76 625.86L92.75 433.32L84.64 437.17C30.86 544.71 0 665.46 0 793.27C0 921.07 30.86 1041.82 84.64 1149.35L342.08 950.16Z"
          />
          <path
            fill="#eb4335"
            d="M793.5 306.73C942.5 306.73 1043.01 371.07 1100.32 424.84L1324.26 206.25C1186.72 78.45 1007.74 0 793.5 0C483.15 0 215.12 178.04 84.64 437.17L341.2 636.37C405.57 445.11 583.66 306.73 793.5 306.73Z"
          />
        </g>
      </svg>
    );
  } else if (name === "Amazon") {
    return (
      <svg
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1801 1529"
        width="1801"
        height="1529"
      >
        <g id="#333333ff">
          <path
            id="Layer"
            fill-rule="evenodd"
            fill="#000000"
            d="M865.6 2.92C932.54 -1.3 1000.24 5.42 1064.84 23.59C1097.19 33.59 1129.35 45.13 1158.62 62.4C1202.2 87.38 1240.76 122.79 1264.93 167.2C1286.44 206.17 1296.79 250.26 1300.99 294.29C1305.71 344.47 1304.7 394.95 1304.59 445.3C1304.59 540.46 1304.59 635.64 1304.59 730.79C1304.75 762.16 1303.24 793.87 1309.78 824.76C1315.49 855.16 1328.65 883.74 1346.07 909.15C1358.35 927.45 1371.95 944.81 1384.7 962.75C1394.55 977.1 1397.43 999.43 1382.88 1011.75C1332.07 1054.72 1281.07 1097.46 1231.25 1141.56C1223.13 1148.55 1214.29 1156.01 1203.27 1157.39C1191.65 1158.96 1178.81 1156.33 1169.86 1148.41C1143.65 1126.78 1118.76 1103.22 1098.07 1076.15C1083.68 1056.88 1070.68 1036.62 1056.9 1016.92C1027.76 1045.5 997.7 1073.47 964.36 1097.1C927.95 1122.08 887.57 1141.83 844.45 1151.9C798.51 1163.5 750.75 1164.56 703.63 1164.72C671.86 1162.98 639.75 1159.77 609.51 1149.31C573.01 1138.52 538.75 1120.22 509.83 1095.44C471.27 1062.97 443.48 1018.72 428.13 970.92C412.86 924.78 409.19 875.73 409.91 827.44C412.7 762 431.88 696.62 469.41 642.56C499.83 597.7 541.9 561.23 589.02 534.79C639.97 506.08 696.68 489.73 753.7 478.1C840.2 460.32 928.47 454.25 1016.09 444.62C1015.58 408.06 1017.87 371.34 1013.46 334.94C1009.75 303.37 997.66 271.2 972.83 250.22C943.54 225.3 903.56 215.54 865.69 217.93C822.88 218.96 779.44 234.7 748.93 265.35C728.94 285.34 716.06 311.67 710.42 339.21C707.11 354.98 697.13 371.03 680.85 375.62C674.49 378.25 667.7 376.36 661.2 375.57C600.51 369.59 539.94 362.71 479.32 356.12C470.31 355.56 461.96 351.15 454.99 345.67C445.44 337.91 442.04 324.6 444.61 312.82C456.82 241.4 491.1 173.29 543.61 123.04C598.44 69.39 670.69 36.85 744.62 19.38C784.35 10.25 824.86 4.45 865.6 2.92ZM870.19 622.33C830.39 632.35 790.62 648.57 760.8 677.64C729.55 706.94 713.32 749.32 710.35 791.5C708.66 828.97 712.22 868.25 731.01 901.5C748.53 933.32 782.05 956.01 818.48 958.75C850.07 963.34 882.22 954.57 909.67 939.08C937.15 922.21 959.66 897.95 975.91 870.23C995.56 836.14 1008.04 798.03 1012.31 758.9C1017.89 708.65 1015.67 657.99 1015.91 607.53C967.05 608.07 917.84 610.77 870.19 622.33Z"
          />
        </g>
        <g id="#ff9201ff">
          <path
            id="Layer"
            fill="#ff9201"
            d="M1633.6 1124.04C1665.24 1120.76 1697.26 1121.32 1728.76 1125.57C1749.96 1128.49 1772.04 1132.02 1790.41 1143.69C1796.59 1147.36 1798.23 1154.87 1799.45 1161.41C1802.57 1181.85 1800.42 1202.63 1797.49 1222.95C1791.06 1263.13 1779.06 1302.44 1761.76 1339.29C1744.5 1377.09 1720.98 1412.5 1690.17 1440.63C1684.33 1445.87 1678.75 1452.53 1670.66 1454.08C1666.12 1454.6 1659.96 1454.35 1657.77 1449.58C1654.72 1442.61 1658.56 1435.39 1660.83 1428.85C1676.23 1390.49 1691.05 1351.86 1702.79 1312.22C1709.65 1288.25 1716.1 1263.81 1716.66 1238.76C1716.57 1227.81 1715.42 1214.95 1706.14 1207.64C1697.53 1201.16 1686.8 1198.22 1676.41 1196.04C1653.7 1192.51 1630.68 1191.56 1607.77 1192.78C1566.31 1193.25 1525.12 1198.22 1483.99 1203.1C1478.46 1203.5 1472.3 1204.49 1467.35 1201.5C1461.51 1196.73 1463.76 1187.67 1468.43 1182.93C1477.04 1173.82 1488.38 1167.95 1499.15 1161.77C1540.36 1139.08 1587.08 1128.49 1633.6 1124.04Z"
          />
          <path
            id="Layer"
            fill="#ff9201"
            d="M9.96 1159.09C20.19 1154.33 30.08 1161.25 38.72 1166.11C158.65 1235.3 287.58 1288.03 420.3 1327.04C466.3 1339.43 512.31 1352.04 559.19 1360.74C585.49 1365.62 611.64 1371.49 638.13 1375.31C687.48 1382.49 736.97 1389.12 786.75 1392.58C905.18 1401.17 1024.59 1398.56 1142.27 1382.37C1238.64 1370.57 1333.5 1348.56 1426.54 1321.17C1486.17 1303.47 1544.25 1281.01 1601.95 1257.87C1616.83 1251.98 1637.61 1258.73 1641.86 1275.3C1645.36 1288.2 1635.74 1299.9 1625.62 1306.55C1564.46 1350.67 1498.25 1387.79 1428.86 1417.29C1328.69 1460.85 1222.77 1490.53 1115.18 1508.97C1064.55 1516.48 1013.73 1523.85 962.49 1525.4C910.93 1528.89 859.2 1526.95 807.66 1524.19C734.27 1518.72 661.22 1508.27 589.52 1491.72C544.75 1480.09 499.85 1468.67 456.43 1452.66C294.57 1396.29 144.3 1307.43 16.41 1193.38C10.99 1188.37 3.87 1183.81 2.56 1175.94C0.92 1169.44 3.84 1162.06 9.96 1159.09Z"
          />
        </g>
      </svg>
    );
  }
  return null;
};

export default DeviceVendorIcon;
